import type React from 'react';
import { createContext, useCallback, useMemo, useState } from 'react';
import type { GuestSession, GuestSessionContextValue, GuestSessionProviderProps } from './types';

export const GuestSessionContext = createContext<GuestSessionContextValue | null>(null);

export const GuestSessionProvider: React.FC<GuestSessionProviderProps> = ({ children }) => {
  const [guestSession, setGuestSession] = useState<GuestSession | null>(null);

  const startGuestSession = useCallback((session: GuestSession) => {
    setGuestSession(session);
  }, []);

  const clearGuestSession = useCallback(() => {
    setGuestSession(null);
  }, []);

  const value = useMemo<GuestSessionContextValue>(
    () => ({ guestSession, startGuestSession, clearGuestSession }),
    [guestSession, startGuestSession, clearGuestSession],
  );

  return <GuestSessionContext.Provider value={value}>{children}</GuestSessionContext.Provider>;
};
